import Model from 'flarum/common/Model';
export default class Warning extends Model {
  publicComment() {
    return Model.attribute('publicComment').call(this);
  }
  privateComment() {
    return Model.attribute('privateComment').call(this);
  }
  strikes() {
    return Model.attribute('strikes').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  hiddenAt() {
    return Model.attribute('hiddenAt', Model.transformDate).call(this);
  }
  isHidden() {
    // Read the server's flag rather than deriving from hiddenAt, which is only
    // serialized while the warning is hidden and so goes stale on restore.
    return Model.attribute('isHidden').call(this);
  }
  warnedUser() {
    return Model.hasOne('warnedUser').call(this);
  }
  hiddenByUser() {
    return Model.hasOne('hiddenByUser').call(this);
  }
  addedByUser() {
    return Model.hasOne('addedByUser').call(this);
  }
  post() {
    return Model.hasOne('post').call(this);
  }
}
flarum.reg.add('fof-moderator-warnings', 'forum/model/Warning', Warning);